import moment from 'moment';
import React from 'react';

import { getAgendaEngine } from './engine';
import { toAgendaAppointments } from './selectors';
import { NativeDayView } from './native/NativeDayView';

export function AgendaDaySurface(props: {
    schedules: any[] | undefined;
    date: moment.Moment;
    settingsAgenda: any;
    selectedRange: { start: number; end: number } | undefined;
    setSelectedRange: React.Dispatch<React.SetStateAction<{ start: number; end: number } | undefined>>;
    renderAppointment: (args: {
        schedule: any;
        layout?: {
            heightPx?: number;
            topPx?: number;
            isMobileViewport?: boolean;
            stackedTop?: boolean;
            stackedBottom?: boolean;
        };
    }) => React.ReactNode;
    onAppointmentDrop?: (args: {
        schedule: any;
        startAt: Date;
        startMinutes: number;
        durationMinutes: number;
    }) => Promise<void> | void;
    onInvalidAppointmentDrop?: (args: {
        schedule: any;
        reason: 'conflict';
    }) => void;
}) {
    const {
        schedules,
        date,
        settingsAgenda,
        selectedRange,
        setSelectedRange,
        renderAppointment,
        onAppointmentDrop,
        onInvalidAppointmentDrop,
    } = props;

    const appointments = toAgendaAppointments(schedules);
    const engine = getAgendaEngine();

    if (engine !== 'native') {
        // Nao esperado: mantemos fallback seguro.
        console.warn('[AGENDA] engine invalida, usando native:', engine);
    }

    return (
        <NativeDayView
            appointments={appointments}
            date={date}
            settingsAgenda={settingsAgenda}
            selectedRange={selectedRange}
            setSelectedRange={setSelectedRange}
            renderAppointment={renderAppointment}
            onAppointmentDrop={onAppointmentDrop}
            onInvalidAppointmentDrop={onInvalidAppointmentDrop}
        />
    );
}
